import { AppConfig } from '../../../app/app.config';
import { SyncUpItemHelper } from '../../../vas/business-objects/sync-up-item/sync-up-item.helper';
import { entityFactory } from '../../helpers/entity-factory';
import { omit } from '../../util/utils';
import { BaseObjectAction, isRestfulAction } from '../actions/base-actions';

export const handleSubmitAction = (state, action: BaseObjectAction, pk = 'id') => {
    const item = action.payload;

    if (!item) {
        console.error(Error('payload cannot be null'));
        return state;
    }

    if (!item[pk] || !item[pk].length) {
        throw new Error(`primary key property ${pk} is missing from payload`);
    }

    // if the item does not exist in our state
    if (state.ids.indexOf(item[pk]) === -1) {
        return handleAddAction(state, action, pk);
    }
    return handleUpdateAction(state, action, pk);
};

export const handleAddAction = (state, action, pk = 'id') => {

    const item = action.payload;

    if (isRestfulAction(action)) {
        action.changeQItem = SyncUpItemHelper.getChangeItem(action.entity, action.payload.modifiedBy, item, undefined);
    }
    AppConfig.debugQueries && console.log('reducer create %s', action.entity, item);
    return {
        ...state,
        ids: [...state.ids, item[pk]],
        entities: {
            ...state.entities,
            [item[pk]]: item
        }
    };
};

const handleUpdateAction = (state, action, pk = 'id') => {
    const item = action.payload;
    let data;

    if (typeof item === 'object') {
        data = {
            ...state.entities[item[pk]],
            ...item
        };
    } else {
        data = {
            ...state.entities[item[pk]],
            item
        };
    }

    const entity = entityFactory(action.entity, data);

    if (isRestfulAction(action)) {
        action.changeQItem = SyncUpItemHelper.getChangeItem(action.entity, action.payload.modifiedBy, entity, state.entities[item[pk]]);
    }
    AppConfig.debugQueries && console.log('reducer update %s', action.entity, state.entities[item[pk]], item);
    return {
        ...state,
        entities: {
            ...state.entities,
            [item[pk]]: entity
        }
    };
};

export const handleRemoveAction = (state, action, pk = 'id') => {
    const item = action.payload;

    if (!item) {
        console.warn(Error('payload cannot be null'));
        return state;
    }

    if (!item[pk] || !item[pk].length) {
        console.warn(new Error(`primary key property ${pk} is missing from payload`));
        return state;
    }

    // if the item does not exist in our state
    if (state.ids.indexOf(item[pk]) === -1) { // ... ignore
        return state;
    }

    if (isRestfulAction(action)) {
        action.changeQItem = SyncUpItemHelper.getChangeItem(action.entity, action.payload.modifiedBy, undefined, action.payload);
    }
    AppConfig.debugQueries && console.log('reducer remove %s', action.entity, item);
    return {
        ...state,
        ids: state.ids.filter(id => id !== item[pk]),
        entities: omit(state.entities, item[pk])
    };
};

export const handleSetFilterAction = (state, action) => {
    return {
        ...state,
        filters: {
            ...state.filters,
            ...action.payload,
            offset: 0
        }
    };
};

export const handleLoadNextPageAction = (state, action) => {
    if (state.ids.length === state.total) {
        return state;
    }

    const stateOffset = state.filters.offset || 0;
    const limit = AppConfig.JOB_LIST_PAGE.limit;
    const maxOffset = Math.ceil(state.total / limit) * limit;
    const offset = Math.min(maxOffset, stateOffset + limit);
    return {
        ...state,
        filters: {
            ...state.filters,
            offset,
            limit
        }
    };
};

export const handleSetTotalAction = (state, action) => {
    return {
        ...state,
        total: action.payload
    };
};

export const handleRehydrateAction = (state, action) => {
    return {
        ...state,
        ...action.payload.reduce((p, c) => {
            p.ids.push(c.id);
            p.entities[c.id] = c;
            return p;
        }, {ids: [], entities: {}})
    };
};



// WEBPACK FOOTER //
// ./src/core/store/helpers/reducer-helper.ts